import * as yup from "yup";
import i18next from "i18next";

export const resetPassSchema = yup.object().shape({
  password: yup
    .string()
    .required(() => i18next.t("auth.validation.passwordRequired", { ns: "admin" }) as string)
    .min(6, () => i18next.t("auth.validation.passwordTooShort", { ns: "admin" }) as string)
    .max(50),
  passwordConfirm: yup
    .string()
    .required(() => i18next.t("auth.validation.passwordRequired", { ns: "admin" }) as string)
    .min(6, () => i18next.t("auth.validation.passwordTooShort", { ns: "admin" }) as string)
    .max(50)
    .oneOf([yup.ref("password")], () => i18next.t("auth.validation.passwordsMustMatch", { ns: "admin" }) as string),
});